import React from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import { scrollTo } from 'libraries/front-end-core/helpers/document'
import url from 'libraries/front-end-core/core/url'
import { DASHBOARD } from 'constants/controllers'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import logoBlackAbbrImg from 'images/fc-logo-abbr-black.svg'
import logoBlackImg from 'images/fc-logo-black.svg'
import selectNewsAol from 'redux/selectors/selectNewsAol'

const LogoLink = ({ className, pageId, activePage }) => {
  const activePageIsDashboard = activePage === DASHBOARD
  const { isMobile } = useSelector(selectDeviceType)
  const newsAol = useSelector(selectNewsAol)

  const handleLogoClick = () => {
    if (activePageIsDashboard) {
      scrollTo({ pageId, id: 0, animate: true, useWindowScrollTo: isMobile })
    }
  }

  return (
    <div {...{ className }} data-testid='logo-link'>
      <a
        className='db'
        href={url(DASHBOARD, newsAol ? { aol: newsAol } : {})}
        onClick={handleLogoClick}
        data-event-category='Logo'
        data-event-action='Select'
      >
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <img className='db w13 h-100' src={logoBlackImg} alt='Logo' />
        </Box>
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <img className='db w9 header-icon-mobile-width h-100' src={logoBlackAbbrImg} alt='Logo' />
        </Box>
      </a>
    </div>
  )
}

export default LogoLink
